import App from './components/App.svelte';

import packageJson from '../../package.json';

console.log(`version ${packageJson.version}`);

const app = new App({
	target: document.body,
	props: { }
});